import React, { useState } from "react";
import emailjs from '@emailjs/browser';
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  Link,
  Alert,
  Collapse,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";
import MusicNoteIcon from "@mui/icons-material/MusicNote"; // Ícono para TikTok

const API_URL = "https://smtp.maileroo.com/send";
const API_KEY =
  "d88cf5f7c759b9bfcada70c21d268574ba70872b6705d65b8b11febd6bcd3c6b";

const Contactos = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    correo: "",
    celular: "",
    mensaje: "",
  });

  const [alert, setAlert] = useState({
    type: "",
    message: "",
    open: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const result = await emailjs.send(
        "service_rsjfavz",
        "template_4co8ir2",
        {
          from_name: formData.nombre,
          from_email: formData.correo,
          celular: formData.celular,
          message: formData.mensaje,
        },
        "8r9WJhkk-FHnLbtay"
      );

      setAlert({
        open: true,
        type: "success",
        message: "Correo enviado correctamente",
      });
    } catch (error) {
      setAlert({
        open: true,
        type: "error",
        message: "Hubo un error al enviar el mensaje",
      });
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Título */}
      <Box textAlign="center" mb={6}>
        <Typography
          variant="h3"
          gutterBottom
          fontWeight={700}
          color="primary"
        >
          Contáctanos
        </Typography>
        <Typography variant="h5" color="text.secondary">
          Estamos aquí para ayudarte
        </Typography>
      </Box>

      {/* Cards de contacto */}
      <Grid container spacing={4} justifyContent="center" mb={6}>
        {/* Facebook */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: "center", p: 2, height: "100%" }}>
            <FacebookIcon
              sx={{ fontSize: 60, color: "#1877F2", mb: 2 }}
            />
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Síguenos en Facebook
              </Typography>
              <Link
                href="https://www.facebook.com/profile.php?id=61562821235317"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                underline="hover"
              >
                Visitar Facebook
              </Link>
            </CardContent>
          </Card>
        </Grid>

        {/* TikTok */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: "center", p: 2, height: "100%" }}>
            <MusicNoteIcon
              sx={{ fontSize: 60, color: "#000000", mb: 2 }}
            />
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Mira nuestros videos
              </Typography>
              <Link
                href="https://www.tiktok.com/@conta.pues.oficia3"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                underline="hover"
              >
                Ver en TikTok
              </Link>
            </CardContent>
          </Card>
        </Grid>

        {/* Ubicación */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: "center", p: 2, height: "100%" }}>
            <LocationOnIcon
              sx={{ fontSize: 60, color: "#3F51B5", mb: 2 }}
            />
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Visítanos
              </Typography>
              <Typography variant="body1">
                C.E. Edificio Histórico 2do Piso (FCEFA)
              </Typography>
              <Typography variant="body1">
                6 de Octubre, Potosí y Cochabamba
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Formulario de contacto */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" gutterBottom>
          Envíanos un mensaje
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Completa el siguiente formulario para ponerte en contacto
          con nosotros.
        </Typography>
      </Box>

      {/* Alertas */}
      <Collapse in={alert.open}>
        <Alert
          severity={alert.type}
          action={
            <IconButton
              color="inherit"
              size="small"
              onClick={() => setAlert({ ...alert, open: false })}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 4 }}
        >
          {alert.message}
        </Alert>
      </Collapse>

      {/* Formulario */}
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={6}>
          <Card sx={{ p: 4, boxShadow: 3 }}>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                margin="normal"
                required
              />
              <TextField
                fullWidth
                label="Correo Electrónico"
                name="correo"
                type="email"
                value={formData.correo}
                onChange={handleChange}
                margin="normal"
                required
              />
              <TextField
                fullWidth
                label="Número de Celular"
                name="celular"
                type="tel"
                value={formData.celular}
                onChange={handleChange}
                margin="normal"
              />
              <TextField
                fullWidth
                label="Mensaje"
                name="mensaje"
                multiline
                rows={4}
                value={formData.mensaje}
                onChange={handleChange}
                margin="normal"
                required
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                Enviar
              </Button>
            </form>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contactos;
